import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=2cbbc4d0&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=ts&"
export * from "./Default.vue?vue&type=script&lang=ts&"
import style0 from "./Default.vue?vue&type=style&index=0&id=2cbbc4d0&scoped=true&lang=css&"
import style1 from "./Default.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbbc4d0",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QFooter,QDrawer} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QFooter,QDrawer})
